export const IS_OPEN_CONTEXT_MENU_CLASS = '__context-is-open';
export const ROW_HAS_ERROR = 'row-has-error';
export const ROW_HAS_WARNING = 'row-has-warning';
export const ROW_PUBLISH_SCHEDULING = 'row-publish-scheduling';
